import { BaseNomenclature } from "./baseNomenclature.model";

export class ShippingType extends BaseNomenclature {
    constructor() {
    super()
    this.collection_name="shipping_type";  
    }
}